<template>
  <!-- <app-data-editor :id="id"
    title="Редактирование артикула"
    resource="articles"
    :elements="elements"
    addMessage="Артикул добавлен"
    editMessage="Артикул изменен"
  @change="(payload) => isChanged = payload"></app-data-editor>-->
  <v-card :flat="isModal ? true : false">
    <v-card-title class="pb-0">
      <h1 class="headline">
        Редактирование артикула
      </h1>
      <v-chip class="mx-3">
        <span>Дата создания:&nbsp;</span>
        <span class="font-weight-black"> {{ entity.date | date }}</span>
      </v-chip>
    </v-card-title>
    <v-card-text class="px-2 pt-4">
      <v-form v-model="isValid">
        <v-layout row>
          <v-flex xs4>
            <TitleTextField
              v-model="entity.title"
              :required="true"
              :rules="[v => v.length>0 || '' ]"
              :input-language="inputLanguage"
              label="Наименование*"
              class="mx-2"
              @input="entityChange"
            />
          </v-flex>
          <v-flex xs4>
            <app-reference
              v-model="entity.model"
              class="mx-2 mb-3"
              label="Модель"
              resource="trademark-models"
              :data-restored="entityRestored"
              component-name="trademark-model"
              :outline="true"
              :height-field="44"
              @input="entityChange(),modelChanged()"
            />
          </v-flex>
          <v-flex xs4>
            <app-reference
              v-model="entity.trademark"
              class="mx-2 mb-3"
              label="ТМ*"
              :rules="[v=>v!== null||'']"
              resource="trademarks"
              :data-restored="entityRestored"
              component-name="trademark"
              :outline="true"
              :height-field="44"
              @input="entityChange(),trademarkChanged()"
            />
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            <app-reference
              v-model="entity.manufacturer"
              class="mx-2 mb-3"
              label="Производитель*"
              :rules="[v=>v!=null||'']"
              resource="manufacturers"
              :data-restored="entityRestored"
              component-name="manufacturer"
              :outline="true"
              :height-field="44"
              :disabled="true"
              @input="entityChange()"
            />
          </v-flex>
          <v-flex xs4>
            <app-reference
              v-model="entity.nomenclature"
              class="mx-2 mb-3"
              label="Номеклатура*"
              :rules="[v=>v!=null||'']"
              resource="nomenclatures"
              :data-restored="entityRestored"
              component-name="nomenclature"
              :outline="true"
              :height-field="44"
              @input="entityChange()"
            />
          </v-flex>
          <v-flex xs4>
            <app-reference
              v-model="entity.productCategory"
              class="mx-2 mb-3"
              label="Категория"
              resource="product-categories"
              :data-restored="entityRestored"
              component-name="product-category"
              :outline="true"
              :height-field="44"
              @input="entityChange()"
            />
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            <TitleTextField
              v-model="entity.weightNetto"
              :input-language="inputLanguage"
              label="Вес нетто"
              class="mx-2"
              @input="entityChange"
            />
          </v-flex>
          <v-flex xs4>
            <TitleTextField
              v-model="entity.weightBrutto"
              :input-language="inputLanguage"
              label="Вес брутто"
              class="mx-2"
              @input="entityChange"
            />
          </v-flex>
          <v-flex xs4>
            <app-reference
              v-model="entity.unit"
              class="mx-2 mb-3"
              label="Единица измерения*"
              :rules="[v=>v!=null||'']"
              resource="units"
              :data-restored="entityRestored"
              component-name="unit"
              :outline="true"
              :height-field="44"
              @input="entityChange()"
            />
          </v-flex>
          <v-flex xs4>
            <TitleTextField
              v-model="entity.material"
              :required="true"
              :rules="[v => v.length>0 || '' ]"
              :input-language="inputLanguage"
              label="Материал*"
              class="mx-2"
              @input="entityChange"
            />
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs6>
            <TitleTextField
              v-model="entity.dimensions"
              :input-language="inputLanguage"
              label="Размеры"
              class="mx-2"
              @input="entityChange"
            />
          </v-flex>
          <v-flex xs6>
            <TitleTextField
              v-model="entity.productSite"
              :input-language="inputLanguage"
              label="Сайт продукта"
              class="mx-2"
              @input="entityChange"
            />
          </v-flex>
          <v-flex xs6>
            <app-reference
              v-model="entity.country"
              class="mx-2 mb-3"
              label="Страна происхождения*"
              :rules="[v=>v!=null||'']"
              resource="countries"
              :data-restored="entityRestored"
              component-name="country"
              :outline="true"
              :height-field="44"
              @input="entityChange()"
            />
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="entity.customsNumber"
              label="Таможенный код"
              class="mx-2"
              outline
              height="44"
              @input="entityChange"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-layout>
            <v-btn
              small
              color="primary"
              :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
              data-test="saveButton"
              @click="submit(false)"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="!isModal"
              small
              color="primary"
              :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
              data-test="saveAndCloseButton"
              @click="submit(true)"
            >
              Сохранить и закрыть
            </v-btn>
            <v-btn
              small
              data-test="cancelButton"
              @click="cancel"
            >
              Отмена
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="id!=='0' && !isModal"
              small
              :color="entity.isRemoved ? 'success' :'error'"
              :data-test="entity.isRemoved ? 'restoreButton' : 'deleteButton'"
              @click="changeRemovedState"
            >
              {{ entity.isRemoved ? "Восстановить" : "Удалить" }}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
import { NestedEditorsEventBus } from "../../components/nested-editors/nested-editors-event-bus.js";
import TitleTextField from "../../components/text-fields/TitleTextField.vue";
import * as articlesApi from "../../backend/articlesApi.js";

export default {
  components: {
    TitleTextField,
  },
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      isValid: false,
      entity: {
        title: "",
        model: null,
        trademark: null,
        manufacturer: null,
        nomenclature: null,
        weightNetto: "",
        weightBrutto: "",
        unit: null,
        material: "",
        dimensions: "",
        productCategory: null,
        productSite: "",
        country: null,
        date: null,
        customsNumber: null,
      },
      loading: false,
      resource: "articles",
      entityRestored: false,
    };
  },
  computed: {
    isModal() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
    inputLanguage() {
      return this.entity.country ? this.entity.country.inputLanguage : "";
    },
  },
  created() {
    if (this.id !== "0") {
      this.getData();
    } else {
      this.entity.date = new Date().toISOString().substr(0, 10);
    }
  },
  mounted() {
    if (this.isModal) {
      NestedEditorsEventBus.$emit("modal-editor-mounted");
    }
  },
  methods: {
    async getData() {
      this.loading = true;
      this.entity = await articlesApi.getArcticle(this.resource, this.id);
      this.entityRestored = true;
      this.loading = false;
    },
    async submit(closeAfterSubmit) {
      const entity = {
        id: +this.id,
        title: this.entity.title,
        weightBrutto: this.entity.weightBrutto,
        weightNetto: this.entity.weightNetto,
        material: this.entity.material,
        dimensions: this.entity.dimensions,
        nomenclatureId: this.entity.nomenclature.id,
        modelId: this.entity.model ? this.entity.model.id : null,
        trademarkId: this.entity.trademark.id,
        manufacturerId: this.entity.manufacturer.id,
        unitId: this.entity.unit.id,
        productCategoryId: this.entity.productCategory ? this.entity.productCategory.id : null,
        productSite: this.entity.productSite,
        countryId: this.entity.country.id,
        date: this.entity.date,
        customsNumber: this.entity.customsNumber,
      };

      if (this.entity.id && this.entity.id > 0) {
        this.loading = true;
        await articlesApi.updateArticle(this.resource, this.entity.id, entity);
        this.showInfo("Артикул изменен");
        this.isChanged = false;
        if (closeAfterSubmit) {
          this.$router.go(-1);
        }
        this.loading = false;
      } else {
        this.loading = true;
        const res = await articlesApi.createArticle(this.resource, entity);
        this.showInfo("Артикул добавлен");
        this.entity.id = res.data;
        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", this.entity.id);
        } else {
          if (closeAfterSubmit) {
            this.$router.go(-1);
          }
          this.$router.replace(`/${this.resource}/${res.data}`);
          this.loading = false;
        }
      }
    },
    cancel() {
      if (this.isModal) {
        NestedEditorsEventBus.$emit("close");
        return;
      }
      this.$router.go(-1);
    },
    async changeRemovedState() {
      await articlesApi.changeRemovedState(
        this.resource,
        this.id,
        this.entity.isRemoved,
      );
      this.entity.isRemoved = !this.entity.isRemoved;
    },
    entityChange() {
      if (!this.entityRestored && !this.isModal && this.id !== "0") {
        return;
      }
      this.isChanged = true;
    },
    async trademarkChanged() {
      if (this.entity.trademark) {
        const res = await articlesApi.trademarkChange(this.entity.trademark.id);
        if (res.data && res.data.Manufacturer) {
          this.$set(this.entity, "manufacturer", {
            id: res.data.Manufacturer.Id,
            title: res.data.Manufacturer.Title,
          });
        }
      } else {
        this.$set(this.entity, "manufacturer", null);
      }
    },
    async modelChanged() {
      if (this.entity.model) {
        const res = await articlesApi.modelChange(this.entity.model.id);
        if (res.data) {
          if (res.data.Trademark) {
            this.$set(this.entity, "trademark", {
              id: res.data.Trademark.Id,
              title: res.data.Trademark.Title,
            });
            this.trademarkChanged();
          }
          if (res.data.Nomenclature) {
            this.$set(this.entity, "nomenclature", {
              id: res.data.Nomenclature.Id,
              title: res.data.Nomenclature.Title,
            });
          }
          if (res.data.Unit) {
            this.$set(this.entity, "unit", {
              id: res.data.Unit.Id,
              title: res.data.Unit.Title,
            });
          }
          if (res.data.Country) {
            this.$set(this.entity, "country", {
              id: res.data.Country.Id,
              title: res.data.Country.Title,
            });
          }
        }
      } else {
        //this.$set(this.entity, "manufacturer", null);
      }
    },
    resetLoaders() {
      this.loading = false;
    },
  },
};
</script>
